import React, { Component, Fragment } from 'react';
import { string, array } from 'prop-types';

import MaskedInput from './MaskedInput';
import WithValidation from './WithValidation';
import InputLabel from 'elements/Inputs/InputLabel';
import { Consumer } from './FormField';

import styles from './CCDateInput.css';

export default class CCDateInput extends Component {
  static propTypes = {
    placeholder: string,
    type: string,
    customClasses: string,
    validations: array,
    label: string
  };

  static defaultProps = {
    placeholder: 'MM / YY',
    type: 'text',
    customClasses: ''
  };

  state = { value: '' };

  handleChange = e => {
    const { value } = e.currentTarget;

    this.setState({ value });
  }

  render() {
    const { placeholder, type, customClasses, validations, label } = this.props;
    const { value } = this.state;

    return (
      <Consumer>
        {sharedProps =>
          <WithValidation
            value={value}
            validations={validations}
            render={
              error => (
                <Fragment>
                  <InputLabel {...sharedProps} label={label} />
                  <MaskedInput
                    sharedProps={sharedProps}
                    customClasses={`${customClasses} ${styles.ccDateInput}`}
                    placeholder={placeholder}
                    onChange={this.handleChange}
                    value={value}
                    error={error}
                    type={type}
                    label={label}
                  />
                </Fragment>
              )
            }
          />
        }
      </Consumer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/uis/elements/Inputs/CCDateInput.js